import _ from 'lodash';

const root = (state) => _.get(state, 'SelectForVerificationState');

export const getApplicationFilters = (state) =>
  _.get(root(state), 'applicationFilters');

export const getIsConfirmationReview = (state) =>
  _.get(root(state), 'isConfirmationReview');



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/state/selectors.js